import React, { Component } from 'react'
import VideoPlayer from "../Helper/VideoPlayer"
import face from "../../assets/images/face.png";
import ear from "../../assets/images/ear.png";


export default class HeadImpulseTest extends Component {
  constructor(props){
    super(props);
    this.state = {
      correctiveSaccade: false,
      hearingLoss:null
    }
  }

  // onOptionCSClick = (cs) => {
  //   this.setState({correctiveSaccade:cs}) 
  // }

  // onOptionHlClick = (hl) => {
  //   this.setState({hearingLoss:hl}) 
  // }

  onInnerClick = (correctiveSaccade, hearingLoss) =>{
    const {onClick} = this.props;
   

    if(!correctiveSaccade){ //no
      onClick(17,true)
    }
    else if(correctiveSaccade && hearingLoss == null){ //no
      this.setState({correctiveSaccade}) 
    }
    else if(correctiveSaccade && !hearingLoss){ // cs yes and ringing no
      onClick(14,true)
    }
    else if(correctiveSaccade && hearingLoss){ // cs and ringing yes
      onClick(13,true)
    }

  }

  render() {
      const {correctiveSaccade, hearingLoss} = this.state;
    return (
        <div>
          
          <div className="mt-3">
              <div className="row">
                <div className="col-lg-6">
                  <h2>Our next step is to perform a maneuver called the Head Impulse Test (HIT)</h2>
                  <p>
                  What we’re doing here is looking for an eye movement called a corrective saccade. This happens when the eyes cannot move smoothly from one target to the next, and make small jerky movements
                  </p>
                  <p>
                  Check out the demonstration and perform the test as shown.
                  </p>
                  <p>
                   Did you notice any corrective saccade?

                  </p>
                </div>
                <div className="offset-lg-1 col-lg-5">
                    <VideoPlayer src="https://www.youtube.com/embed/psyPED6anPo" thumbnail="Head Impulse Test-15.jpg" width="300"/>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-6 ">
                  <div className="row bk-l-blue m-1">
                  <img className="col-2 rel p-1" src={face} alt="face"/>
                    <div className="p-0 col-4 text-center">
                      <h5 className="m-0">Eye Wobble</h5>
                      <p className="m-0">(Corrective Saccade)</p>
                    </div>
                    <div className="p-0 col-6 text-right">
                    <button className="btn btn-danger"  onClick={this.onInnerClick.bind(this,true,hearingLoss)}>Yes</button>
                    <button className="btn btn-danger m-1"  onClick={this.onInnerClick.bind(this,false,null)}>No</button>
                    </div>
                  </div>
                </div>
                {correctiveSaccade && <div className="col-lg-6 z-index-1">
                  <div className="row bk-l-blue m-1">
                    <img className="col-2 rel p-1" src={ear} alt="ear"/>
                    <h5 className="p-0 col-4 text-center">Hearing Loss or Ear Ringing</h5>
                    <div className="p-0  col-6 text-right">
                      <button className="btn btn-danger"  onClick={this.onInnerClick.bind(this,true,true)}>Yes</button>
                      <button className="btn btn-danger m-1"  onClick={this.onInnerClick.bind(this,true,false)}>No</button>
                    </div>
                  </div>
                </div>}
              </div>
          </div>
         
        </div>

    )
  }
}
